// Resolves ANY valid ISO 4217 currency code to its proper symbol via the browser's built-in
// Intl API — covers all ~170 currencies (not just a hand-picked few), so the homepage's full
// currency dropdown (AED, AFN, ALL, ... ZWL) is fully supported without maintaining a manual map.
// Falls back to the bare code itself for anything Intl doesn't recognise (always readable).
const symbolCache = {};

export function getCurrencySymbol(currencyCode) {
  if (!currencyCode) return "";

  if (symbolCache[currencyCode] !== undefined) {
    return symbolCache[currencyCode];
  }

  let symbol = currencyCode;
  try {
    const parts = new Intl.NumberFormat("en", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "narrowSymbol",
    }).formatToParts(1);
    const symbolPart = parts.find((p) => p.type === "currency");
    if (symbolPart?.value) {
      symbol = symbolPart.value;
    }
  } catch (err) {
    // Invalid/unrecognised code — keep the bare code as the fallback.
  }

  symbolCache[currencyCode] = symbol;
  return symbol;
}
